import { createComponent, OnEscapeListener } from '@carvana/merch-components';
import React, { useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import COOKIES from '~/constants/cookies';
import NativeCapability from '~/constants/vdp/nativeCapability';
import BrowserCookies from '~/utilities/BrowserCookies';

const Button = createComponent('button', { className: 'rounded px-16 py-8' });

type OwnProps = {
  errorMessage: string;
  onCancel: () => void;
  onSave: (branchName: string, nativeAppCapabilities: string[]) => void;
};

const nativeAppCapabilityOptions = Object.values(NativeCapability);

export default function Prompt(props: OwnProps) {
  const currentNativeAppCapabilities = BrowserCookies.get(
    COOKIES.nativeAppCapabilities
  );

  const onSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const branchName = String(data.get('branch-name') ?? '');
    const nativeAppCapabilities = Array.from(
      data.getAll('native-app-capability')
    ).map(v => String(v));

    props.onSave(branchName, nativeAppCapabilities);
  };

  useEffect(() => {
    document.getElementById('branch-name')?.focus();
    document.body.classList.add('no-scroll');

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <FocusLock autoFocus={false}>
      <OnEscapeListener onEscape={props.onCancel}>
        <div
          className="fixed inset-0 z-[1000] bg-grey-5/50"
          onClick={props.onCancel}
          data-analytics-id={null}
        ></div>
        <form
          className="fixed top-0 z-[1000] flex w-full p-8"
          onSubmit={onSubmit}
          onReset={props.onCancel}
        >
          <div className="mx-auto flex w-[400px] flex-col gap-16 rounded-[6px] bg-[#3c3c3c] px-32 py-16">
            <label htmlFor="branch-name" className="sr-only">
              Branch Name
            </label>
            <input
              type="text"
              id="branch-name"
              name="branch-name"
              placeholder="Branch Name"
              className="rounded px-16 py-8"
            />

            <div>
              {nativeAppCapabilityOptions.map(nativeAppCapability => {
                const isSet = Boolean(
                  currentNativeAppCapabilities?.includes(nativeAppCapability)
                );

                return (
                  <label
                    key={nativeAppCapability}
                    className="flex gap-8 text-white"
                  >
                    <input
                      type="checkbox"
                      name="native-app-capability"
                      value={nativeAppCapability}
                      disabled={isSet}
                      defaultChecked={isSet}
                    />
                    <span>{nativeAppCapability}</span>
                  </label>
                );
              })}
            </div>

            {props.errorMessage ? (
              <div className="text-[#feaaaa]">{props.errorMessage}</div>
            ) : null}

            <div className="flex justify-end gap-16">
              <Button type="reset" data-analytics-id={null}>
                Cancel
              </Button>
              <Button type="submit" data-analytics-id={null}>
                Save
              </Button>
            </div>
          </div>
        </form>
      </OnEscapeListener>
    </FocusLock>
  );
}
